import { fireTrackingEvent, isInternalTraffic } from 'utils/tracking'

import { isProduction } from 'constants/env'
import { PRIMARY_SEARCH_INDEX } from 'constants/instantSearch'

export const MAP_ALGOLIA_INSIGHTS_TO_GTM_TRIGGER = {
  clickedObjectIDsAfterSearch: 'product_card_click_after_search',
  clickedObjectIDs: 'product_card_click',
  convertedObjectIDsAfterSearch: 'product_conversion_after_search',
  convertedFilters: 'filter_conversion',
  addedToCartObjectIDsAfterSearch: 'success_add_to_cart_after_search',
  addedToCartObjectIDs: 'success_add_to_cart',
  purchasedObjectIDsAfterSearch: 'product_purchased_after_search',
  purchasedObjectIDs: 'product_purchased',
  convertedObjectIDs: 'product_conversion',
  clickedFilters: 'filter_apply',
  viewedObjectIDs: 'product_list_view',
  viewedFilters: 'filter_view',
}

export const getAlgoliaObjectId = (productId: string, variantId: number) => {
  return `${productId}.${variantId}`
}

export const fireProductClickTrackingEvent = (event: string, productId: string, productName: string) => {
  fireTrackingEvent('track', {
    insightsMethod: 'clickedObjectIDs',
    index: PRIMARY_SEARCH_INDEX,
    event,
    productCardName: productName,
    objectIDs: [`${productId}.1`],
  })
}

export const isEnableAlgoliaAnalytics = () => {
  // collect analytics on prod with non-internal traffic and on no-prod env unconditionally
  return (!isInternalTraffic() && isProduction) || !isProduction
}
